var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaterBudget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2679_1201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9896 0.0537109H11.0104C4.9295 0.0537109 0 4.89966 0 10.8775V47.23C0 53.2078 4.9295 58.0537 11.0104 58.0537H47.9896C54.0705 58.0537 59 53.2078 59 47.23V10.8775C59 4.89966 54.0705 0.0537109 47.9896 0.0537109Z",
    fill: "#9C79EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0303 30.9306C35.0303 33.9331 32.5548 36.3667 29.5005 36.3667C26.4462 36.3667 23.9707 33.9331 23.9707 30.9306C23.9707 29.9139 24.2545 28.9595 24.7548 28.1447L29.5005 19.8125L34.2462 28.1447C34.7465 28.9595 35.0303 29.9139 35.0303 30.9306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7773 29.0971C13.7773 20.5302 20.8419 13.5854 29.5564 13.5854C35.5476 13.5854 40.759 16.8679 43.431 21.7033",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9225 26.1169L39.1748 23.6304C38.8232 23.4984 38.5313 23.2317 38.348 22.9058C38.1546 22.5618 38.0838 22.1592 38.1727 21.7879C38.265 21.4226 38.4856 21.1532 38.784 21.0225L38.7433 20.9502L45.3802 17.3444L45.3836 17.3505C45.6531 17.2041 45.9732 17.1719 46.3093 17.2887C47.04 17.5297 47.5152 18.3509 47.3597 19.0969L45.9225 26.1169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.054 29.6401C46.054 38.207 38.9895 45.1517 30.275 45.1517C24.2838 45.1517 19.0724 41.8693 16.4004 37.0339",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3208 33.1177L20.1006 35.2475C20.4017 35.3606 20.6518 35.589 20.8087 35.8682C20.9744 36.1628 21.035 36.5077 20.9589 36.8257C20.8798 37.1386 20.6909 37.3694 20.4353 37.4813L20.4702 37.5433L14.7852 40.6319L14.7823 40.6267C14.5516 40.7521 14.2774 40.7796 13.9895 40.6796C13.3635 40.4732 12.9565 39.7698 13.0897 39.1307L14.3208 33.1177Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2679_1201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 58,
    fill: "white",
    transform: "translate(0 0.0537109)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterBudget);
export default __webpack_public_path__ + "static/media/water-budget.3031b1d5b50374c0676debd72f4da170.svg";
export { ForwardRef as ReactComponent };